import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-emerald-950 text-base-bg flex items-center justify-center px-6" data-testid="not-found-page">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        className="w-full max-w-xl text-center"
      >
        <p className="text-[0.72rem] uppercase tracking-[0.22em] text-sand mb-6">TILT Ventures Ltd.</p>
        <h1 className="font-serif text-7xl md:text-8xl leading-none">404</h1>
        <p className="mt-6 font-serif text-2xl md:text-3xl text-base-bg/90">This page could not be found.</p>
        <p className="mt-4 text-base-bg/60 max-w-md mx-auto">
          The page you're looking for may have been moved, or it never existed. Let's get you back on track.
        </p>
        <button
          data-testid="notfound-home-button"
          onClick={() => navigate("/")}
          className="group mt-10 inline-flex items-center gap-3 bg-base-bg px-8 py-4 text-sm uppercase tracking-[0.18em] text-emerald-950 transition-opacity hover:opacity-90"
        >
          <ArrowLeft className="h-4 w-4 transition-transform duration-300 group-hover:-translate-x-1" />
          Return home
        </button>
      </motion.div>
    </div>
  );
}
